// extracted by mini-css-extract-plugin
export default {"value":"MyTextLabel_value__9yaVk"};